import { Container, Grid, Typography } from '@mui/material';

export default function DataNotFound({ message = 'No Record Found!' }) {
  return (
    <Container>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={6}>
          <Typography align="center">{message}</Typography>
        </Grid>
      </Grid>
    </Container>
  );
}

// import { Container, Row, Col } from 'react-bootstrap';

// export default function DataNotFound({ message = 'No Record Found!' }) {
//   return (
//     <Container>
//       <Row className="justify-content-center">
//         <Col xs={12} md={6}>
//           <div className="text-center">{message}</div>
//         </Col>
//       </Row>
//     </Container>
//   );
// }
